<template>
  <div class="step-counter">
    <span class="step-label">{{ d['Salary.Counter']?.item2 }} {{ formattedStep }}</span>
  </div>
</template>

<script>
import { computed } from 'vue'
import { state, localDictionary } from '@/lib/state'

export default {
  setup() {
    const currentPage = computed(() => state.currentPage + 1) // Adjust for 0-based index
    const maxSteps = computed(() => state.questions.length)

    // Make sure small numbers are padded with a leading zero
    const formattedStep = computed(() => {
      const pad = (num) => String(num).padStart(2, '0')
      return `${pad(currentPage.value)}/${pad(maxSteps.value)}`
    })

    return {
      formattedStep,
      d: localDictionary(),
    }
  },
}
</script>

<style scoped>
.step-counter {
  font-size: var(--font-size-body);
  align-self: flex-end;
}

@media (min-width: 1024px) {
  .step-counter {
    color: var(--color-white);
    align-self: flex-start;
    text-transform: uppercase;
    letter-spacing: 1.4px;
    font-weight: var(--font-weight-regular);
  }
}
</style>
